// Module
var code = "<wt-generic-search-bar class=\"fill\" criteria=\"vm.searchCriteria\" filtered-items=\"vm.filteredItems\" items=\"vm.items\" placeholder=\"Search (id: ID t:title u:user due:duedate cat:category)\" search-string=\"vm.searchString\"> </wt-generic-search-bar>";
// Exports
module.exports = code;